import {
  USER_PERMISSIONS_STORAGE_KEY,
  USER_TAXIPARK_STORAGE_KEY,
} from '~/shared/config/constants'
import { storageGet, storageRemove, storageSet } from '~/shared/lib/storage'

import {
  Permissions,
  UserOptionsMe,
  UserOptionsStoreType,
  UserTaxipark,
} from './types'

export class UserOptionsStore implements UserOptionsStoreType {
  private readonly storageKeyPermissions = USER_PERMISSIONS_STORAGE_KEY

  private readonly storageKeyTaxipark = USER_TAXIPARK_STORAGE_KEY

  private fallbackPermissions: Permissions = null

  private fallbackTaxipark: UserTaxipark | null = null

  get permissions(): Permissions {
    const storageByKey = storageGet<Permissions>(this.storageKeyPermissions)

    return this.fallbackPermissions || storageByKey
  }

  get taxipark(): UserTaxipark | null {
    const storageByKey = storageGet<UserTaxipark>(this.storageKeyTaxipark)

    return this.fallbackTaxipark || storageByKey
  }

  save(options: UserOptionsMe) {
    const { permissions, taxipark } = options

    storageSet<Permissions>(this.storageKeyPermissions, permissions)
    storageSet<UserTaxipark | null>(this.storageKeyTaxipark, taxipark ?? null)

    this.fallbackPermissions = permissions
    this.fallbackTaxipark = taxipark ?? null
  }

  clear() {
    storageRemove(this.storageKeyPermissions)
    storageRemove(this.storageKeyTaxipark)

    this.fallbackPermissions = null
    this.fallbackTaxipark = null
  }
}
